import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'
import { Radar, type RadarIndicator } from '../Radar'
import { ScoreRadarProps } from './ScoreRadar.types'

const ScoreRadarWrapper = styled.div<{ $clickable: boolean }>`
  display: inline-block;

  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
      border-radius: ${({ theme }) => theme.borderRadius.medium};
      transition: ${({ theme }) => theme.transitions.default};

      &:hover {
        transform: scale(1.05);
        box-shadow: ${({ theme }) => theme.shadows.md};
      }
    `}
`

export const ScoreRadar: React.FC<ScoreRadarProps> = ({
  property,
  size = 40,
  className,
  getScoreColor,
  onClick,
}) => {
  const { t } = useTranslation()

  const indicators: RadarIndicator[] = [
    {
      name: t('common.scoreModal.scores.potential.radarLabel'),
      min: 0,
      max: 100,
    },
    {
      name: t('common.scoreModal.scores.legacy.radarLabel'),
      min: 0,
      max: 100,
    },
    {
      name: t('common.scoreModal.scores.geometry.radarLabel'),
      min: 0,
      max: 100,
    },
    {
      name: t('common.scoreModal.scores.livability.radarLabel'),
      min: 0,
      max: 100,
    },
  ]

  const values: number[] = [
    property.under_exploited_score || 0,
    property.existing_score || 0,
    property.geo_shape_score || 0,
    property.livability_score || 0,
  ]

  const averageScore = property.development_score || 0
  const colorScale = getScoreColor ? getScoreColor(averageScore) : '#0294df'

  return (
    <ScoreRadarWrapper $clickable={!!onClick} onClick={onClick} className={className}>
      <Radar
        indicators={indicators}
        values={values}
        centerValue={averageScore}
        color={colorScale}
        size={size}
      />
    </ScoreRadarWrapper>
  )
}
